import { Footer } from '@boozt/app/components/organisms';
import { Content, App } from '@boozt/app/containers';
import type { ApiResponseRouterReduxStore, AppProps } from '@boozt/types';
import React from 'react';

export const getLayoutComponents = (): Record<string, any> => ({
    content: Content,
    footer: Footer,
});

export function loadComponent<T extends AppProps>(
    Component: React.ComponentType<T>,
    props: T,
    state: ApiResponseRouterReduxStore | null,
): React.FunctionComponentElement<any> {
    return React.createElement(App, {
        ...props,
        initialState: state,
    }, React.createElement(Component, props));
}
